var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('div',{staticClass:"iframe-page-wrap"},[(_vm.hasClose)?_c('div',{staticClass:"iframe-page_close",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("x")]):_vm._e(),_c('iframe',{attrs:{"src":_vm.src}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }